import { ReactNode } from 'react';

interface SectionHeadingProps {
  title: string;
  /** Optional trailing action, e.g. a "See all →" link button. */
  action?: ReactNode;
  className?: string;
}

/**
 * THE in-page section title: 20px bold ink with an optional trailing action.
 * Replaces the hand-rolled h2s (Welcome), full-bleed band strips
 * (OperatingHours) and bare largeHeader Labels used as section dividers.
 */
export const SectionHeading = ({
  title,
  action,
  className = '',
}: SectionHeadingProps) => (
  <div className={`mb-3 flex items-center justify-between ${className}`}>
    <h2 className="text-xl font-bold text-ink">{title}</h2>
    {action}
  </div>
);
